/*
 * @Author: Suroc
 * @Date: 2024-07-19 10:26:42
 * @LastEditTime: 2024-09-26 16:43:46
 * @Description: 钱包管理 Store，包含邀请 ID 和钱包账户管理功能
 */
import { defineStore } from 'pinia'
export const userWalletStore = defineStore('wallet', {
  state: () => ({
    inviteId: null, // 邀请码
    account: localStorage.getItem('userAccount') || null, // 当前账号
    accountData: [], // 所有账号
    currentAccount: localStorage.getItem('flst:user') ? JSON.parse(localStorage.getItem('flst:user')) : {},
    upUser:localStorage.getItem('flst:upUser') ? JSON.parse(localStorage.getItem('flst:upUser')) : {},
  }),
  actions: {
    // 设置邀请码
    setInviteId(ID) {
      this.inviteId = null
      this.inviteId = ID
    },

    // 激活并存储账号信息
    acitveAccount(account) {
      this.account = null
      this.account = account ? account : null
      localStorage.setItem('userAccount', account)
    },

    // 设置多个账号数据
    setAccount(arr) {
      this.accountData = []
      this.accountData = arr
    },

    // 清除账号信息
    clearAccount() {
      this.account = null
      this.accountData = []
      localStorage.removeItem('userAccount')
    },
    // 设置当前账号
    setCurrentAccout(account) {
      for (let key in account) {
        this.currentAccount[key] = account[key]
      }
      localStorage.setItem("flst:user", JSON.stringify(this.currentAccount))
    },
    // 设置账号的某一个信息
    setCurrentAccoutItem(info) {
      for (let i in info) {
        for (let j in state) {
          if (i === j) {
            this.currentAccount[j] = info[i]
          }
        }
      }
      localStorage.setItem("flst:user", this.currentAccount)
    },
    // 上级账号信息
    setUpUserData(account){
        for (let key in account) {
          this.upUser[key] = account[key]
        }
      localStorage.setItem("flst:upUser", JSON.stringify(this.upUser))
    },
    // 清除当前账号信息和上级信息
    clearCurrentAccount(){
      this.upUser = {}
      this.currentAccount = {}
      localStorage.removeItem("flst:user")
      localStorage.removeItem("flst:upUser")
    }
  },
})